import React, { useContext, useEffect, useState } from 'react';
import { isLoggedIn } from '@/api/base';
import { Cart } from '@shop/models/src/cart';
import * as cartApi from '@/api/cart';
import { storage } from '@/utils/storage';
import { env } from '@/utils/env';

export const CartContext = React.createContext<{
  cart: Cart | null;
  setCart(_: Cart | null): void;
  clearCart(): void;
  loading: boolean;
  empty: boolean;
}>({
  cart: null,
  setCart: () => {},
  clearCart: () => {},
  loading: false,
  empty: false,
});

const EMPTY_CART = { items: [] };

export default function CartProvider({
  children,
}: React.PropsWithChildren<{}>) {
  if (env.isSSR() || __SS_BOT__) return children;

  const [cart, setCart] = useState<Cart | null>(() => {
    const cache = storage.local.cart.get();
    return cache ?? EMPTY_CART;
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isLoggedIn()) {
      setLoading(true);
      cartApi
        .getCart()
        .then((res) => {
          updateCart(res.body);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);

  function updateCart(v: Cart) {
    setCart(v);
    storage.local.cart.set(v);
  }

  function clearCart() {
    setCart(EMPTY_CART as any);
    storage.local.cart.remove();
  }

  const empty = !loading && cart != null && !cart.items.length;

  return (
    <CartContext.Provider
      value={{
        cart,
        setCart: updateCart,
        clearCart,
        loading,
        empty,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCartCtx() {
  return useContext(CartContext);
}
